jQuery(document).ready(function ($) {

    if ($("#ofcategory").length > 0) {
        $("#ofcategory option[value='479']").remove(); //unlisted category ID
    }

    if ($("#desktop-video-frame").length > 0) {
        var desktopPlayer = new Vimeo.Player('desktop-video-frame');
        desktopPlayer.play();
    }

    if ($("#mobile-video-frame").length > 0) {
        var mobilePlayer = new Vimeo.Player('mobile-video-frame');
        mobilePlayer.play();
    }

    if ($(".swiper").length > 0) {
        const swiper = new Swiper('.swiper', {
            // Optional parameters
            direction: 'vertical',
            loop: false,
            speed: 1000,
            //effect: 'fade',
            //autoplay: true,

/* mousescroll*/
            mousewheel: {
                releaseOnEdges: true,
            },
       
            // If we need pagination
            pagination: {
            el: '.swiper-pagination',
            },
        
            // Navigation arrows
            navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
            },
        
            // And if we need scrollbar
            scrollbar: {
            el: '.swiper-scrollbar',
            },
        });
    }

    $('.navigation-trigger').on('click', function() {
        $('body').toggleClass('no-scroll-fix');
    });


    /* toggle side menu on mobile */
    $('#submenu').click(function() {
        $(this).next().toggle('fast');
        $(this).toggleClass('active');
    });

    $('#dsingle').click(function() {
        $('#dmonthly').removeClass('active');
        $(this).addClass('active');
        $('#single-donation').removeClass('hidden');
        $('#monthly-donation').addClass('hidden');
    });
    $('#dmonthly').click(function() {
        $('#dsingle').removeClass('active');
        $(this).addClass('active');
        $('#monthly-donation').removeClass('hidden');
        $('#single-donation').addClass('hidden');
    });

    // NINJA FORMS
    //redirect after cancelling payment
    if (window.location.href.indexOf("donate/?nf_resume=3&nfs_checkout=cancel") > -1) {
        window.location.replace("https://www.socialdemocrats.ie/donate/");
    }
    if (window.location.href.indexOf("join/?nf_resume=5&nfs_checkout=cancel") > -1) {
        window.location.replace("https://www.socialdemocrats.ie/join/");
    }
    if (window.location.href.indexOf("join/?nf_resume=6&nfs_checkout=cancel") > -1) {
        window.location.replace("https://www.socialdemocrats.ie/join/");
    }
    
    
    // add extra form step
    $(function() {
        $(window).on('load', addEL);
    });
    function addEL() {
        $('ul.nf-breadcrumbs').append($('<li class="extra-step"><a href="#" class="nf-breadcrumb" data-index="3"> Payment</a></li>'));
    }
    // Execute after NF is loaded - after clicking to next step
	$(document).on( 'nfFormReady', function( e, layoutView ) {
		
		nfRadio.channel( 'nfMP' ).on( 'change:part', function($) {
			
            if(jQuery('#single-donation ul.nf-breadcrumbs li').hasClass('extra-step')){
                console.log('Already added');
            } else {
                jQuery('#single-donation ul.nf-breadcrumbs').append(jQuery('<li class="extra-step"><a href="#" class="nf-breadcrumb" data-index="3"> Payment</a></li>'));
            }

            if(jQuery('#monthly-donation ul.nf-breadcrumbs li').hasClass('extra-step')){
                console.log('Already added');
            } else {
                jQuery('#monthly-donation ul.nf-breadcrumbs').append(jQuery('<li class="extra-step"><a href="#" class="nf-breadcrumb" data-index="3"> Payment</a></li>'));
            }

            if(jQuery('#nf-form-5-cont ul.nf-breadcrumbs li').hasClass('extra-step')){
                console.log('Already added');
            } else {
                jQuery('#nf-form-5-cont ul.nf-breadcrumbs').append(jQuery('<li class="extra-step"><a href="#" class="nf-breadcrumb" data-index="3"> Payment</a></li>'));
            }

            if(jQuery('#nf-form-6-cont ul.nf-breadcrumbs li').hasClass('extra-step')){
                console.log('Already added');
            } else {
                jQuery('#nf-form-6-cont ul.nf-breadcrumbs').append(jQuery('<li class="extra-step"><a href="#" class="nf-breadcrumb" data-index="3"> Payment</a></li>'));
            }

		});

	});

    $(document).on('change', 'input', function() {
        if(jQuery('#single-donation ul.nf-breadcrumbs li').hasClass('extra-step')){
            console.log('Already added');
        } else {
            jQuery('#single-donation ul.nf-breadcrumbs').append(jQuery('<li class="extra-step"><a href="#" class="nf-breadcrumb" data-index="3"> Payment</a></li>'));
        }

        if(jQuery('#monthly-donation ul.nf-breadcrumbs li').hasClass('extra-step')){
            console.log('Already added');
        } else {
            jQuery('#monthly-donation ul.nf-breadcrumbs').append(jQuery('<li class="extra-step"><a href="#" class="nf-breadcrumb" data-index="3"> Payment</a></li>'));
        }

        if(jQuery('#nf-form-5-cont ul.nf-breadcrumbs li').hasClass('extra-step')){
            console.log('Already added');
        } else {
            jQuery('#nf-form-5-cont ul.nf-breadcrumbs').append(jQuery('<li class="extra-step"><a href="#" class="nf-breadcrumb" data-index="3"> Payment</a></li>'));
        }
    });

}); 
